import React from 'react'
import { Col } from 'reactstrap'

const ReviewStatus = () => {
  return (
 <div className='col-3 add'>
    
    <select className='form-control'>
              <option value="approved">الحالة</option>
      <option value="approved">Approved</option>
      <option value="pending">Pending</option>
      <option value="rejected">Rejected</option>
    </select>
 </div>
 


  )
}

export default ReviewStatus